import PreviewDetailImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from '../common';

const routes = [
    {
     matchRegex: '/Site/Detail/:id',
        name: 'Site detail',
        slots: [
            SLOT_KEY.SLOT_SECTION,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'site-detail-wrapper', label: 'Site Detail Wrapper' }
            ]
        }
    },
]

export default routes;

